<template>
  <Modal
    hide-close-button
    :modal-style="{ width: '450px' }"
    :title="displayTitle"
  >
    <div class="column main q-px-lg">
      <div
        v-if="error"
        class="q-mb-xl text-center"
      >
        <QIcon
          color="red"
          name="fa fa-times"
        />
        <div class="text-h5 q-ma-md">
          {{ error }}
        </div>
      </div>
      <div v-else>
        <div class="row q-ml-none q-mt-lg">
          <div
            v-for="reason in reasons"
            :key="reason.option"
            class="full-width"
          >
            <RadioCircle
              v-model="selectedReason"
              name="reason"
              :value="reason"
            >
              {{ reason.description }}
            </RadioCircle>
          </div>
        </div>
      </div>
      <div
        class="buttons"
        :class="error ? 'text-center' : ''"
      >
        <QBtn
          aria-label="Close"
          flat
          label="Close"
          @click="$emit('close')"
        />
        <QBtn
          v-if="!error"
          aria-label="Cancel"
          color="black"
          :disable="!selectedReason.option"
          label="Submit"
          @click="handleCancel"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import RadioCircle from "shared/components/core/forms/RadioCircle.vue";
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "CancelMediaOrTranscriptRequestModal",
  components: {
    Modal,
    RadioCircle,
  },
  props: {
    error: {
      type: String,
      default: null,
    },
  },
  emits: ["close", "cancel"],
  data() {
    return {
      selectedReason: {},
      reasons: [
        {
          option: "A",
          description: "Duplicate request",
        },
        {
          option: "B",
          description: "Unqualified item/false positive",
        },
        {
          option: "C",
          description: "AM processing error",
        },
        {
          option: "D",
          description: "Technical issue",
        },
        {
          option: "E",
          description: "User cancelled",
        },
        {
          option: "F",
          description: "Test Request",
        },
      ],
    };
  },
  computed: {
    displayTitle() {
      return this.error ? "" : "Why would you like to cancel this media item?";
    },
  },
  methods: {
    handleCancel() {
      this.$emit("cancel", this.selectedReason);
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.radio-circle) {
  border: 1px solid rgb(118 118 188 / 45%);
}

:deep(.streem-modal2-header) {
  margin-bottom: 0;
}

.q-icon {
  font-size: 10em;
}

.buttons {
  margin-left: auto;
}
</style>
